import React, { useEffect } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { classnames } from '@bydesign-ui/utils';
import { useRefCallback } from '@bydesign-ui/hooks';
import { AvatarTrigger } from './components/AvatarTrigger';
import { FileList } from './components/FileList';
import { RcTrigger, RcUploadProvider, useCreateFileUpload } from './rc-upload';
export function AvatarUpload(props) {
  var className = props.className,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$accept = props.accept,
      accept = _props$accept === void 0 ? 'image/*' : _props$accept,
      _props$size = props.size,
      size = _props$size === void 0 ? {
    width: '120px',
    height: '120px'
  } : _props$size,
      _props$autoUpload = props.autoUpload,
      autoUpload = _props$autoUpload === void 0 ? true : _props$autoUpload,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? [] : _props$actions,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$maxLength = props.maxLength,
      maxLength = _props$maxLength === void 0 ? -1 : _props$maxLength,
      uploadUrl = props.uploadUrl,
      name = props.name,
      _props$headers = props.headers,
      headers = _props$headers === void 0 ? {} : _props$headers,
      _props$data = props.data,
      data = _props$data === void 0 ? {} : _props$data,
      _props$withCredential = props.withCredentials,
      withCredentials = _props$withCredential === void 0 ? false : _props$withCredential,
      value = props.value,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      onError = props.onError,
      customRequest = props.customRequest,
      children = props.children;

  if (!Array.isArray(value)) {
    multiple = false;
  }

  var cls = classnames(usePrefixCls('upload-avatar', {
    single: !multiple
  }), className);
  var triggerCls = classnames(usePrefixCls('upload-file-list-avatar-trigger'));
  var localeCount = useLocale('upload.error.overflow-count');
  var handleError = useRefCallback(onError);
  var handleChange = useRefCallback(onChange);
  var handleValueChange = useRefCallback(onValueChange);
  var fileUpload = useCreateFileUpload();
  useEffect(function () {
    var valueChange = function valueChange(files) {
      if (Array.isArray(value)) {
        handleValueChange && handleValueChange(files);
      } else {
        handleValueChange && files.length > 0 && handleValueChange(files[0]);
      }
    };

    fileUpload.addListener('error', handleError);
    fileUpload.addListener('change', handleChange);
    fileUpload.addListener('value-change', valueChange);
    return function () {
      fileUpload.removeListener('error', handleError);
      fileUpload.removeListener('change', handleChange);
      fileUpload.removeListener('value-change', valueChange);
      fileUpload.destroy();
    };
  }, []);
  useEffect(function () {
    fileUpload.updateOptions({
      maxLength: maxLength,
      autoUpload: autoUpload,
      uploadUrl: uploadUrl,
      name: name,
      accept: accept,
      multiple: multiple,
      withCredentials: withCredentials,
      headers: headers,
      data: data,
      errors: {
        overflowCount: localeCount
      },
      customRequest: customRequest
    });
  }, [maxLength, autoUpload, uploadUrl, name, accept, multiple, headers, data, withCredentials, customRequest]);
  useEffect(function () {
    fileUpload.updateValue(Array.isArray(value) ? value.map(function (i) {
      return Object.assign({}, i, {
        fileType: "image"
      });
    }) : value ? [Object.assign({}, value, {
      fileType: "image"
    })] : []);
  }, [value, multiple]);
  return React.createElement(RcUploadProvider, {
    upload: fileUpload
  }, React.createElement("div", {
    className: cls
  }, React.createElement(FileList, {
    disableAnimation: true,
    type: "picture",
    size: size,
    actions: actions
  }, (!value || Array.isArray(value)) && React.createElement(RcTrigger, {
    className: triggerCls,
    disabled: disabled,
    accept: accept,
    multiple: multiple
  }, React.createElement(AvatarTrigger, {
    disabled: disabled,
    children: children
  })))));
}